// Get Stripe Billing
export const GET_STRIPE_BILLING_REQUEST = 'GET_STRIPE_BILLING_REQUEST';
export const GET_STRIPE_BILLING_DONE = 'GET_STRIPE_BILLING_DONE';
export const GET_STRIPE_BILLING_FAILED = 'GET_STRIPE_BILLING_FAILED';
